"use client";

import { I18nextProvider } from "react-i18next";
import { ReactNode } from "react";
import { Resource, createInstance } from "i18next";
import initTranslations from "./i18n";
import { DefinedLocale } from "./locale-definitions";

// This provider is a Client Component that creates an i18next instance on the client and
// uses the I18nextProvider to provide the instance to all descendent Client Components.

export default function TranslationsProvider({
	children,
	locale,
	namespaces,
	resources,
}: {
	children: ReactNode;
	locale: DefinedLocale;
	namespaces: string[];
	resources: Resource;
}) {
	const i18n = createInstance();

	initTranslations(locale, namespaces, i18n, resources);

	return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
